<template>
  <div>
    <div v-if="item.type === 0">
      <v-radio-group
        v-model="item.boolVal"
        class="pt-0"
        row
        hide-details="auto"
        :disabled="disabled"
      >
        <v-radio label="Ja" :value="true" :ripple="false"></v-radio>
        <v-radio label="Nei" :value="false" :ripple="false"></v-radio>
      </v-radio-group>
    </div>

    <div v-if="item.type === 1">
      <v-text-field
        v-model="item.stringVal"
        label="Skriv ditt svar her"
        filled
        hide-details="auto"
        :disabled="disabled"
      ></v-text-field>
    </div>

    <div v-if="item.type === 2">
      <v-select
        v-model="listSelected"
        :items="item.options"
        filled
        item-text="value"
        item-value="key"
        label="Velg"
        hide-details="auto"
        :disabled="disabled"
        @change="changeSelectedList"
      >
      </v-select>
    </div>

    <div v-if="item.type === 3">
      <v-chip
        v-model="option.selected"
        class="ma-1 elevation-2"
        active-class="activeColor"
        v-for="option in item.options"
        :key="option.key"
        filter
        :ripple="false"
        :disabled="disabled"
        @click="option.selected = !option.selected"
      >
        {{ option.value }}
      </v-chip>
    </div>

    <div v-if="item.type === 4">
      <DatePickerDialog v-model="item.dateTimeVal" :disabled="disabled" />
    </div>

    <div v-if="item.type === 5">
      <v-btn
        v-if="item.attachments && item.attachments.length > 0"
        class="mb-2"
        small
        color="primary"
        @click="$refs.dropzone.addAttachment()"
      >
        Legg til fil
      </v-btn>
      <FileDropzone ref="dropzone" v-model="item.attachments" :close="false" />
    </div>

    <div v-if="item.type === 6">
      <v-text-field
        v-model="item.intVal"
        label="Skriv et tall her"
        filled
        hide-details="auto"
        type="number"
        pattern="\d*"
        min="1"
        step="1"
        :disabled="disabled"
      ></v-text-field>
    </div>

    <div v-if="item.type === 7">
      <v-text-field
        v-model="item.doubleVal"
        label="Skriv et tall her"
        filled
        hide-details="auto"
        type="number"
        inputmode="decimal"
        step="0.001"
        :disabled="disabled"
      ></v-text-field>
    </div>

    <div v-if="item.type === 8">
      <v-textarea
        v-model="item.stringVal"
        filled
        name="textarea"
        hide-details="auto"
        :disabled="disabled"
      ></v-textarea>
    </div>

    <div v-if="item.type === 9">
      <v-radio-group
        v-model="item.boolVal"
        class="pt-0"
        row
        hide-details="auto"
        :disabled="disabled"
      >
        <v-radio label="Ok" :value="true" :ripple="false"></v-radio>
        <v-radio label="Ikke relevant" :value="false" :ripple="false"></v-radio>
      </v-radio-group>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import DatePickerDialog from "@/components/shared/date/DatePickerDialog.vue";
import FileDropzone from "@/components/shared/attachments/FileDropzone.vue";

export default Vue.extend({
  name: "ChecklistType",
  props: {
    item: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      testselect: 1,
      listSelected: -1 as number,
    };
  },
  mounted() {
    if (this.item.type === 2) {
      var selected = this.item.options.find((x) => x.selected);
      this.listSelected = selected.key;
    }
  },
  methods: {
    changeSelectedList(newValue) {
      this.item.options.forEach((x) =>
        x.key === newValue ? (x.selected = true) : (x.selected = false)
      );
    },
  },
  components: {
    DatePickerDialog,
    FileDropzone,
  },
});
</script>

<style lang="scss" scoped>
.activeColor {
  color: var(--v-iconOnPrimary-base);
  background-color: var(--v-primary-base);
}
</style>
